App.prototype.openCategoryMenu = function () {
    $('.mobile-category-menu').addClass('active');
};

App.prototype.closeCategoryMenu = function () {
    $('.mobile-category-menu').removeClass('active');
};

$('.open-mobile-menu-button').click(function () {
    App.prototype.openCategoryMenu();
});

$('.close-mobile-category-menu-button').click(function () {
    App.prototype.closeCategoryMenu();
});

document.addEventListener(
    "DOMContentLoaded", () => {
        const mobile_category_menu = document.querySelector( "#mobile-category-menu" );

        if (mobile_category_menu){

            const menu = new MmenuLight(
                mobile_category_menu
            );

            const navigator = menu.navigation({
                title: mobile_category_menu.dataset.title
            });

            const drawer = menu.offcanvas();

            const openers = document.querySelectorAll( 'a[href="#mobile-category-menu"]' );

            if(openers){
                for (const opener of openers) {
                    opener.addEventListener( 'click', ( evnt ) => {
                        evnt.preventDefault();
                        drawer.open();
                    });
                }
            }

        }
    }
);
